export const dynamicPagination = (
    filters: any,
    updateFn: any,
    total: number,
    title: string
) => {
    const pageSizeOptions = (total: number) => {
        const calculateTotal = (size: number) => {
            return Math.floor(total / size);
        };

        return [
            calculateTotal(100),
            calculateTotal(10),
            calculateTotal(4),
            calculateTotal(2),
            total,
        ].filter(size => size > 0);
    };

    return {
        defaultCurrent: filters.page,
        current: filters.page,
        showTitle: true,
        defaultPageSize: filters.limit,
        pageSizeOptions: pageSizeOptions(total),
        onChange: (page: number, pageSize: number) => {
            updateFn({
                offset: (page - 1) * pageSize,
                limit: pageSize,
                page: page,
            });
        },
        total: total,
        showTotal: (total: number) => `${title}: ${total}`,
    };
};
